import dedent from 'dedent';
import { z } from 'zod';
import { FIRST_VERSION_TIMESTAMP, coerceLiteralNumberRequired, zodTDateISODate } from '~/lib/zod';
import { TenantId, createPerformableConfig } from '~/tenants/common/registry';

export type GuideType = z.infer<typeof typeSchema>;

export const typeSchema = z.enum([
  'selling',
  'buyers',
  'after_sale',
  'preparing_for_sale',
  'contract_to_close',
]);

export default createPerformableConfig(
  'guides',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      types: typeSchema
        .array()
        .min(1, { message: 'Select at least one PDF guide' })
        .max(typeSchema.options.length, { message: `Cannot choose more than ${typeSchema.options.length} guides` }),
      need_by: zodTDateISODate('Need By date is required'),
    }),
  },
  {
    name: 'PDF Agent/Broker Guides',
    group: 'Agent Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/print/guides/thumbnail.jpg',
    images: [],
    short: dedent`
      Our digital-only RE Guides are essential tools, covering every stage of the home \
      sale process—from preparing a home for sale and understanding contracts, to buyer \
      and seller tips and post-sale support. Perfect for listing presentations and client \
      meetings, these guides help you provide clear, professional guidance and ensure a \
      smooth, successful transaction.
    `,
  },
);
